import { render, staticRenderFns } from "./MenuTippClip.vue?vue&type=template&id=4c68e187&scoped=true&"
import script from "./MenuTippClip.vue?vue&type=script&lang=js&"
export * from "./MenuTippClip.vue?vue&type=script&lang=js&"
import style0 from "./MenuTippClip.vue?vue&type=style&index=0&id=4c68e187&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c68e187",
  null
  
)

export default component.exports